/**
 * Copies of carried things and containers, made on every tick.
 *
 * These replace `structuredClone`, which cost about a tenth of a solve. Each
 * copy is spread from the original, so it has the same keys in the same order
 * (a state's JSON, and every hash taken of it, must not change), and carries
 * any field an older log's keyframe had. Arrays are copied, never shared: a
 * tick writes to its own copy only. A kind this file does not know falls back
 * to `structuredClone`.
 */

import type { Carryable, Container } from '@overcooked/shared'

export function cloneContainer(container: Container): Container {
  return { ...container, contents: [...container.contents] }
}

export function cloneItem(item: Carryable): Carryable {
  switch (item.type) {
    case 'ingredient':
    case 'equipment':
      return { ...item }
    case 'plate':
      return { ...item, plate: { ...item.plate, contents: [...item.plate.contents] } }
    case 'container':
      return { ...item, container: cloneContainer(item.container) }
    default:
      return structuredClone(item as Carryable)
  }
}
